import { AVAILABLE_STRATEGIES } from './applyStrategies.js'

export const initialState = {
  strategy: AVAILABLE_STRATEGIES[0],
  currentOptions: {
    date: new Date(),
    offset: { weeks: 0, days: 0, hours: 0, minutes: 0 },
  },
  selectedActivities: new Set(),
  selectedStudents: new Set(),
}

export const actions = {
  SET_STRATEGY: 'SET_STRATEGY',
  UPDATE_DATE: 'UPDATE_DATE',
  UPDATE_OFFSET: 'UPDATE_OFFSET',
  TOGGLE_ACTIVITY: 'TOGGLE_ACTIVITY',
  SELECT_ALL_ACTIVITIES: 'SELECT_ALL_ACTIVITIES',
  UNSELECT_ALL_ACTIVITIES: 'UNSELECT_ALL_ACTIVITIES',
  TOGGLE_STUDENT: 'TOGGLE_STUDENT',
  SELECT_STUDENTS: 'SELECT_STUDENTS',
  UNSELECT_STUDENTS: 'UNSELECT_STUDENTS',
  UNSELECT_ALL_STUDENTS: 'UNSELECT_ALL_STUDENTS',
}

export const reducer = (state, action) => {
  switch (action.type) {
    case actions.SET_STRATEGY:
      return {
        ...state,
        strategy: AVAILABLE_STRATEGIES[action.value],
        selectedActivities: new Set(),
        selectedStudents: new Set(),
      }
    case actions.UPDATE_DATE:
      return {
        ...state,
        currentOptions: { ...state.currentOptions, date: action.date },
      }
    case actions.UPDATE_OFFSET: {
      const parsed = parseInt(action.value);
      return {
        ...state,
        currentOptions: {
          ...state.currentOptions,
          offset: { ...state.currentOptions.offset, [action.key]: isNaN(parsed) ? 0 : parsed },
        },
      }
    }
    case actions.TOGGLE_ACTIVITY: {
      const next = new Set(state.selectedActivities)
      next.delete(action.guid) || next.add(action.guid)
      return { ...state, selectedActivities: next }
    }
    case actions.SELECT_ALL_ACTIVITIES:
      return { ...state, selectedActivities: new Set(action.guids) }
    case actions.UNSELECT_ALL_ACTIVITIES:
      return { ...state, selectedActivities: new Set() }
    case actions.TOGGLE_STUDENT: {
      const next = new Set(state.selectedStudents)
      next.delete(action.email) || next.add(action.email)
      return { ...state, selectedStudents: next }
    }
    case actions.SELECT_STUDENTS: {
      const next = new Set(state.selectedStudents)
      action.emails.forEach(email => next.add(email))
      return { ...state, selectedStudents: next }
    }
    case actions.UNSELECT_STUDENTS: {
      const next = new Set(state.selectedStudents)
      action.emails.forEach(email => next.delete(email))
      return { ...state, selectedStudents: next }
    }
    case actions.UNSELECT_ALL_STUDENTS:
      return { ...state, selectedStudents: new Set() }
    default:
      return state
  }
}
